import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";

export const DeleteStream = graphql(/* GraphQL */ `
	mutation DeleteStream($params: DeleteStreamParams!) {
		deleteStream(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useDeleteStream(streamId?: string) {
	const [deleteStream] = useMutation(DeleteStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleDeleteStream = useCallback(async () => {
		if (!streamId) {
			return {
				success: undefined,
				error: undefined,
			};
		}

		const result = await deleteStream({
			variables: {
				params: {
					_id: streamId,
				},
			},
		});

		return {
			success: result.data?.deleteStream.success,
			error: result.data?.deleteStream.error,
		};
	}, [deleteStream, streamId]);

	return { handleDeleteStream };
}
